"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInjectionKey = void 0;
function createInjectionKey(key) {
    return key;
}
exports.createInjectionKey = createInjectionKey;
